/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-status-information-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zm0 3.125a.937.937 0 110 1.875.937.937 0 010-1.875zm2.5 10.7h-5v-1.4h1.8V9.45H8.125v-1.4h2.581v5.625H12.5v1.4z"/>'
  }
})
